/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, SxProps, Theme } from "@mui/material";
import provenExpertGold from "@/src/assets/img/logo/proven_expert_empfehlung_2026.svg";
import React from "react";
import { mergeSx } from "@/src/utils/mergeSx";

export type ProvenExpertSealGoldProps = {
  sx?: SxProps<Theme>;
};

export default function ProvenExpertSealGold({ sx }: ProvenExpertSealGoldProps) {
  return <Box component={"img"} src={provenExpertGold} alt={"Proven Expert Empfehlung"} sx={mergeSx({ display: "block" }, sx)} width={720} height={720} />;
}
